module.exports = __webpack_public_path__ + "img/home_icon.766a4d66.svg";